"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletIncludeFamilyDto = exports.ImportUserIdentifierResponseDto = exports.ImportUserIdentifierDto = exports.UserIdentifierUpdateDto = exports.UserIdentifierCreateDto = exports.UserIdentifierShowDto = exports.UserIdentifierDto = exports.ByOrganizationAndUserIdentifierIdDto = exports.ByOrganizationUserIdentifierDto = exports.ByFacilityUserCustomerIdsPaginatedDto = exports.ByFacilityIdDto = exports.MIN_USER_IDENTIFIER_LENGTH = void 0;
const organization_dto_1 = require("../../organization/dto/organization.dto");
const import_dto_1 = require("../../import/dto/import.dto");
const general_dto_1 = require("../../dto/general.dto");
exports.MIN_USER_IDENTIFIER_LENGTH = 4;
class ByFacilityIdDto {
}
exports.ByFacilityIdDto = ByFacilityIdDto;
class ByFacilityUserCustomerIdsPaginatedDto extends general_dto_1.PaginationQuery {
}
exports.ByFacilityUserCustomerIdsPaginatedDto = ByFacilityUserCustomerIdsPaginatedDto;
class ByOrganizationUserIdentifierDto {
}
exports.ByOrganizationUserIdentifierDto = ByOrganizationUserIdentifierDto;
class ByOrganizationAndUserIdentifierIdDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.ByOrganizationAndUserIdentifierIdDto = ByOrganizationAndUserIdentifierIdDto;
class UserIdentifierCoreDto {
}
class UserIdentifierDto extends UserIdentifierCoreDto {
}
exports.UserIdentifierDto = UserIdentifierDto;
class UserIdentifierShowDto extends UserIdentifierDto {
}
exports.UserIdentifierShowDto = UserIdentifierShowDto;
class UserIdentifierCreateDto extends UserIdentifierCoreDto {
}
exports.UserIdentifierCreateDto = UserIdentifierCreateDto;
class UserIdentifierUpdateDto extends UserIdentifierCreateDto {
}
exports.UserIdentifierUpdateDto = UserIdentifierUpdateDto;
class ImportUserIdentifierDto extends UserIdentifierDto {
}
exports.ImportUserIdentifierDto = ImportUserIdentifierDto;
class ImportUserIdentifierResponseDto extends import_dto_1.ImportResponseDto {
}
exports.ImportUserIdentifierResponseDto = ImportUserIdentifierResponseDto;
class WalletIncludeFamilyDto {
    constructor() {
        this.includeFamily = true;
    }
}
exports.WalletIncludeFamilyDto = WalletIncludeFamilyDto;
//# sourceMappingURL=user-identifier.dto.js.map